<script setup lang="ts">
import GaiaQuote from '@/components/design/base/GaiaQuote.vue';

defineProps<{
  snippets: string[];
}>();

const emit = defineEmits<{
  'highlight-snippet': [text: string];
}>();
</script>

<template>
  <!-- The passages a result was drawn from. Each one is a way into the document
       beside it, so clicking a quote scrolls the preview to it and highlights
       it — which is what the card's "Trace" action opens this for. -->
  <n-flex vertical :size="7" :style="{ paddingTop: '4px' }">
    <gaia-quote
      v-for="(snippet, index) in snippets"
      :key="index"
      interactive
      title="Show in document"
      @click="emit('highlight-snippet', snippet)"
    >
      {{ snippet }}
    </gaia-quote>
  </n-flex>
</template>
